import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainRemoveGroupDevice(deviceId) {
  return maintainRequest({
    url: `/device/maintenanceMan/device_group/removeGroupDevice?deviceId=${deviceId}`,
    method: "post",
  });
}
